"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractSearchForm = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const mui_form_search_1 = require("@dzambalaorg/mui-form-search");
const mui_inputs_core_1 = require("@dzambalaorg/mui-inputs-core");
const types_1 = require("@framework/types");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const types_2 = require("../../types");
const inputs_1 = require("../../inputs");
const ContractSearchForm = (props) => {
    const { contractFeaturesOptions, initialSearchValues, service } = props;
    const columns = {
        [types_2.ServiceType.ADMIN]: [2],
        [types_2.ServiceType.OFFICE]: [3],
    };
    return ((0, jsx_runtime_1.jsx)(mui_form_search_1.SearchWithFilters, { initialValues: initialSearchValues, chipsKeys: ["contractStatus", "contractFeatures"], children: (0, jsx_runtime_1.jsxs)(ui_kit_1.FormGrid, { columns: columns[service], containerProps: { sx: theme => ({ marginTop: theme.spacing(theme.tokens.spacing.xl) }) }, children: [service === types_2.ServiceType.OFFICE && (0, jsx_runtime_1.jsx)(inputs_1.SearchMerchantInput, { disableClear: true }), (0, jsx_runtime_1.jsx)(mui_inputs_core_1.SelectInput, { name: "contractStatus", options: types_1.ContractStatus, multiple: true }), (0, jsx_runtime_1.jsx)(mui_inputs_core_1.SelectInput, { name: "contractFeatures", options: contractFeaturesOptions, multiple: true, disabled: Object.keys(contractFeaturesOptions).length === 0 })] }) }));
};
exports.ContractSearchForm = ContractSearchForm;
//# sourceMappingURL=index.js.map